import React from 'react';

const ArrowRight = ({ className, ariaHidden, focusable }: { className: string, ariaHidden?: boolean, focusable?: boolean }) => {
  return (
    <svg
      className={className}
      xmlns='http://www.w3.org/2000/svg'
      width='15'
      height='12'
      viewBox='0 0 15 12'
      fill='none'
      aria-hidden={ariaHidden}
      focusable={focusable}
    >
      <path
        fill='currentColor'
        d='M1.69531 5.2C1.25348 5.2 0.895312 5.55817 0.895312 6C0.895312 6.44183 1.25348 6.8 1.69531 6.8V5.2ZM14.5667 6.56569C14.8792 6.25327 14.8792 5.74673 14.5667 5.43431L9.47556 0.343146C9.16314 0.0307264 8.65661 0.0307264 8.34419 0.343146C8.03177 0.655565 8.03177 1.1621 8.34419 1.47452L12.8697 6L8.34419 10.5255C8.03177 10.8379 8.03177 11.3444 8.34419 11.6569C8.65661 11.9693 9.16314 11.9693 9.47556 11.6569L14.5667 6.56569ZM1.69531 6.8L14.001 6.8V5.2L1.69531 5.2V6.8Z'
      ></path>
    </svg>
  );
};

export default ArrowRight;
